import FormControl from "@mui/material/FormControl";
import { Button, Drawer, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import React, { useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import { BASE_URL } from "../services/client/rest";

const useStyles = makeStyles(() => ({
  root: {
    flexShrink: 0,
  },
  date1: { border: "1px solid red" },
}));

function NewInstance({
  open,
  onClose,
  queryType,
}: {
  open: boolean;
  onClose: any;
  queryType: number;
}) {
  const [openDrawer, SetOpenDrawer] = React.useState<any>(open);
  const [currentRow, SetCurrentRow] = useState([] as any);
  const [customerType, SetCustomerType] = React.useState(false);
  const [timeZones, SetTimeZones] = React.useState([] as any);

  var bearer = "Bearer " + localStorage.getItem("token");
  const headers = {
    Authorization: bearer,
  };

  function OnSaveClick() {
    if (queryType === 0) {
      currentRow.customerType = "New Ideal Customer";
    } else if (queryType === 1) {
      currentRow.customerType = "New Infinity Customer";
    }
    const request = {
      customerName: currentRow.customerName,
      customerType: currentRow.customerType,
      accountNumber: currentRow.accountNumber,
      serialNumber: currentRow.serialNumber,
      serverTimeZone: currentRow.serverTimeZone,
      numUsers: currentRow.numUsers,
      csiPassword: currentRow.csiPassword,
    };
    let url = BASE_URL + "Customer";

    axios
      .post(url, request, {
        headers,
      })
      .then((response) => {
        if (response.status === 200) {
          alert("Customer Added Successfully!");
        } else {
          alert("Something went Wrong!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  React.useEffect(() => {
    if (queryType == 0) {
      SetCustomerType(true);
    }
    let url = BASE_URL + "Customer/TimeZones/";

    fetch(url + queryType, {
      method: "get",
      headers: new Headers({
        Authorization: bearer,
      }),
    })
      .then((response) => response.json())
      .then((data) => SetTimeZones(data))
      .catch
      //error => alert('Error: ' + error)
      ();
    SetOpenDrawer(open);
  }, [open]);

  function SetValue(key: string, value: any) {
    currentRow[key] = value;
  }

  return (
    <Box>
      <Drawer
        PaperProps={{ style: { width: "auto" } }}
        anchor="right"
        open={openDrawer}
        onClose={() => onClose(0)}
        variant={"temporary"}
      >
        <Box style={{ padding: "5px 10px", marginTop: "15px" }}>
          <Box style={{ width: "100%" }}>
            <Box style={{ marginTop: "12px" }}>
              <TextField
                required
                id="outlined-required"
                label="Customer Name"
                onChange={(e: any) => {
                  SetValue("customerName", e.target.value);
                }}
                style={{ width: "300px" }}
              />
            </Box>
            <Box style={{ marginTop: "10px" }}>
              <TextField
                required
                id="outlined-required"
                label="Customer Type"
                defaultValue={
                  queryType === 0
                    ? "New Ideal Customer"
                    : "New Infinity Customer"
                }
                // onChange={(e: any) => { SetValue('customerType', e.target.value) }}
                style={{ width: "300px" }}
              />
            </Box>
            {queryType === 0 ? (
              <Box style={{ marginTop: "10px" }}>
                <TextField
                  required
                  id="outlined-required"
                  label="Account Number"
                  onChange={(e: any) => {
                    SetValue("accountNumber", e.target.value);
                  }}
                  style={{ width: "300px" }}
                />
              </Box>
            ) : null}

            <Box style={{ marginTop: "10px" }}>
              <TextField
                required
                id="outlined-required"
                label="Serial Number"
                onChange={(e: any) => {
                  SetValue("serialNumber", e.target.value);
                }}
                style={{ width: "300px" }}
              />
            </Box>
            <Box style={{ marginTop: "10px" }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Server Time Zone
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Server Time Zone"
                  onChange={(e: any) => {
                    SetValue("serverTimeZone", e.target.value);
                  }}
                >
                  {timeZones.map((server: any, index: any) => {
                    return <MenuItem value={server}>{server}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Box>
            <Box style={{ marginTop: "10px" }}>
              <TextField
                required
                id="filled-number"
                label="Number of Users"
                onChange={(e: any) => {
                  SetValue("numUsers", e.target.value);
                }}
                type="number"
                variant="outlined"
              />
            </Box>
            <Box style={{ marginTop: "10px" }}>
              <TextField
                required
                id="outlined-required"
                label="CSI Password"
                type="password"
                onChange={(e: any) => {
                  SetValue("csiPassword", e.target.value);
                }}
                style={{ width: "300px" }}
              />
            </Box>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{ padding: "10px", border: "0px solid red" }}
          >
            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={OnSaveClick}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
}
export default NewInstance;
